import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "antd";
import {
  StyledCardButton,
  StyledProjectTitle,
  StyledProjectWrapper,
  StyledTransparentCollapse,
} from "./styled";
import { ContractorsModal } from "../ContractorsModal";
import { InfoCard } from "../InfoCard";
import { ArrowLeft } from "../icons/ArrowLeft";
import { EApproveStatus, TWDContractor } from "../../types";

export const Relevance = () => {
  const [openContractorsModal, setOpenContractorsModal] = useState(false);
  const navigate = useNavigate();

  const project = {
    title: "СГП1",
    status: EApproveStatus.UPDATED,
    date: "01.01.2023",
    sectionId: "sgp1",
  };

  const contractors: TWDContractor[] = [
    {
      id: 1,
      name: "ООО Спецстрой",
      acceptedAt: "",
      status: EApproveStatus.UPDATED,
      shortName: "ООО Спецстрой",
    },
    {
      id: 1,
      name: "ООО Западстройинвест",
      acceptedAt: "11.06.2023",
      status: EApproveStatus.ACTUAL,
      shortName: "ООО Западстройинвест",
    },
    {
      id: 1,
      name: "ИП Фирсов Евгений Никитич",
      acceptedAt: "08.06.2023",
      status: EApproveStatus.ACTUAL,
      shortName: "ИП Фирсов Евгений Никитич",
    },
  ];

  return (
    <StyledProjectWrapper>
      {openContractorsModal && (
        <ContractorsModal
          contractors={contractors}
          title="Актуальность РД – подрядчики"
          onCancel={() => setOpenContractorsModal(false)}
        />
      )}
      <StyledProjectTitle>
        <button
          style={{ border: "none", background: "none" }}
          onClick={() => navigate("/main/projects")}
        >
          <ArrowLeft />
        </button>
        <Typography.Title style={{ marginLeft: "14px" }} level={3}>
          Актуальность РД
        </Typography.Title>
      </StyledProjectTitle>
      <StyledTransparentCollapse
        title="Алхимово"
        children={
          <InfoCard
            lastUpdated="13.07.2022"
            redirectUrl="../projects/alximovo"
            status={EApproveStatus.UPDATED}
            title={project.title}
            extraContent={
              <StyledCardButton
                onClick={(event) => {
                  event.preventDefault();
                  setOpenContractorsModal(true);
                }}
              >
                Смотреть подрядчиков
              </StyledCardButton>
            }
          />
        }
      />
    </StyledProjectWrapper>
  );
};
